<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Disponibilidades</h1>

      <SGPModalComponent v-if="abrirModal" tamanho="lg" titulo="Disponibilidade" @sgpModalFechar="fecharModal"
        :mostrarFooter="false">
        <FormularioCtrlDisponibilidadeComponent :tipoFormulario="tipoFormulario" :disponibilidade="disponibilidadeSelecionado"
          @disponibilidadeSalva="fecharModal" />
      </SGPModalComponent>

      <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

      <template v-if="disponibilidades.length">
        <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao?.current_page">

          <SGPTabelaComponent :colunas="colunas" :dados="disponibilidades" :usuarioPodeEditar="true"
            :usuarioPodeExcluir="false" :botaoInline="false" :somenteLeitura="false"
            @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
            @sgpTabelaEditarSelecionadoEmit="editarSelecionado">
            <template v-slot:item.sincronizar="{ item }">
              <SGPFormBotaoComponent
                fab
                rounded
                color="primary"
                x-small
                :disabled="loadingDisponibilidade"
                @click="handleSincronizarProvedores(item)"
              >
                <v-icon color="white" small>mdi-sync</v-icon>
              </SGPFormBotaoComponent>
            </template>
          </SGPTabelaComponent>
        </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingDisponibilidade" />
    </div>

  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlDisponibilidadeComponent from '../components/FormularioCtrlDisponibilidadeComponent.vue'

export default {
  name: 'CtrlDisponibilidadePage',

  components: {
    FormularioCtrlDisponibilidadeComponent
  },

  data() {
    return {
      mostrarEditar: true,
      disponibilidadesSelecionados: [],
      disponibilidadeSelecionado: {},
      abrirModal: false,
      tipoFormulario: 'salvar'
    }
  },

  created() {
    this.listarDisponibilidades(this.montarParametros());
  },

  computed: {
    ...mapGetters('ctrlDisponibilidade', ['listaDeDisponibilidades', 'loadingDisponibilidade', 'paginacao']),

    disponibilidades() {
      return this.listaDeDisponibilidades.map(disponibilidade => {
        disponibilidade.redirecionar = `/workflow/ctrl-disponibilidade/${disponibilidade.id}/provedores`
        return disponibilidade
      })
    },

    colunas() {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'disponibilidade_sla',
          label: 'Disponibilidade SLA',
          sortable: false
        },
        {
          key: 'redirecionar',
          label: 'Associar Provedores',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlDisponibilidade',
      [
        'listarDisponibilidades',
        'sincronizarProvedores'
      ]),

    gerenciadorDeSelecionados(selecionados) {
      this.disponibilidadesSelecionados = selecionados;
    },

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra,
      }
    },

    adicionarNovo() {
      this.disponibilidadeSelecionado = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal() {
      this.abrirModal = false;
      this.disponibilidadeSelecionado = {};
      this.tipoFormulario = 'salvar';
      this.listarDisponibilidades(this.montarParametros());
    },

    editarSelecionado() {
      this.tipoFormulario = 'editar';
      this.disponibilidadeSelecionado = this.disponibilidadesSelecionados[0];
      this.abrirModal = true;
    },

    async handleSincronizarProvedores(item) {
      try {
        await this.sincronizarProvedores(item.id)
        this.$toast.success('Sincronização realizada com sucesso!')
      } catch (error) {
        this.$toast.error('Erro ao sincronizar provedores')
        console.error('Erro ao sincronizar:', error)
      }
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1
      const perPage = paginate.per_page || this.paginacao?.per_page || 20
      this.listarDisponibilidades(
        this.montarParametros({
          page: current,
          current_page: current,
          per_page: perPage
        })
      )
    },

  }
}
</script>

